import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
  
  public isLoggedIn$ = new BehaviorSubject<boolean>(false); 
  

  ShowLoadingSpinner() {
    this.isLoggedIn$.next(true);
  }

  HideLoadingSpinner() {
    this.isLoggedIn$.next(false);
  }

  
}